import * as reporter from './report';

const cookieLoaderIframeId = 'login_cookie_cross_domain_frame_v2';
const cookiePageUrl = 'https://video.qq.com/cookie/1.0.0/cookie.html';
const messageSource = 'VIDEO_SYNC';
const timeout = 3000;

export default class IframeCookieLoader {
  eventHandlers = {};
  messageQueues = [];
  timers = {};

  constructor() {
    this.initTime = Date.now();
    this.initIframe();
    this.initEvents();
  }

  initEvents() {
    window.addEventListener('message', (e) => {
      if (e?.data?.source !== messageSource) return;

      const { event, action, data } = e.data;
      if (event === 'ready') {
        this.isFrameReady = true;
        this.execQueues();
        reporter.report({
          f_event: reporter.EVENT_INIT_COOKIE_READY,
          f_cost: Date.now() - this.initTime,
        });
      } else if (event === 'action-callback') {
        this.execEvents(action, data);
      }
    });
  }

  execQueues() {
    if (!this.messageQueues.length) return;
    this.messageQueues.forEach((message) => {
      this.postMessage(message);
    });
  }

  emit(action, timeout = 0, data) {
    return new Promise((resolve, reject) => {
      if (!this.eventHandlers[action]) {
        this.eventHandlers[action] = [];
      }
      this.eventHandlers[action].push(resolve);
      this.postMessage({
        action,
        source: messageSource,
        data,
      });
      // 调用超时情况
      if (timeout > 0) {
        this.timers[action] = setTimeout(() => {
          reject(new Error('cookie sync timeout'));
          delete this.eventHandlers[action];
        }, timeout);
      }
    });
  }

  async postMessage(message) {
    if (!this.iframe) {
      await this.initIframe();
    }
    if (!this.isFrameReady) {
      this.messageQueues.push(message);
    } else {
      this.iframe.contentWindow.postMessage(message, '*');
    }
  }

  execEvents(action, data) {
    if (!this.eventHandlers[action]) return;

    const handlers = this.eventHandlers[action];
    if (!handlers.length) return;

    handlers.forEach((handler) => {
      handler(data);
    });

    this.timers[action] && clearTimeout(this.timers[action]);
  }

  getVideoCookie() {
    return this.emit('getCookies', timeout);
  }

  clearVideoCookie() {
    return this.emit('clearCookies', timeout);
  }

  setVideoCookies(cookies) {
    return this.emit('setCookies', timeout, cookies);
  }

  initIframe() {
    this.iframe = document.getElementById(cookieLoaderIframeId);
    this.isLoading = true;

    if (!this.iframe) {
      const iframe = document.createElement('iframe');
      iframe.id = cookieLoaderIframeId;
      iframe.style.display = 'none';
      this.iframe = iframe;
      document.body.appendChild(iframe);
    }

    this.iframe.src = `${cookiePageUrl}?_t=${Date.now()}`;
    this.iframe.onload = () => {
      this.isLoading = false;
      reporter.report({
        f_event: reporter.EVENT_INIT_COOKIE_ONLOAD,
        f_cost: Date.now() - this.initTime,
      });
    };
  }

  static instance;
  static getInstance() {
    if (!this.instance) {
      this.instance = new IframeCookieLoader();
    }

    return this.instance;
  }
}
